import React, { useEffect } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TIPO_CORSO } from "../../../model/tipoCorso";
import it from 'date-fns/locale/it';

registerLocale('it', it);

export default function ContabilizzaManagerForm({
  formContabilizzazioneManager,
  setFormContabilizzazioneManager,
  showModalContabilizzazioneManager,
  selectedItem
}) {

  useEffect(() => {
    if (!showModalContabilizzazioneManager) {
      setFormContabilizzazioneManager({});
    }
  }, [showModalContabilizzazioneManager]);

  const handleDateChange = (date) => {
    setFormContabilizzazioneManager(prevState => ({ 
      ...prevState, 
      data_fattura: date 
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormContabilizzazioneManager(prevState => ({ 
      ...prevState, 
      [name]: value 
    }));
  };

  return (
    <div className="container">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card bg-light">
            <div className="card-body">
              <h6 className="card-subtitle mb-2 text-muted">Dettagli contabilizzazione</h6>
              <p className="mb-1"><strong>Corsista:</strong> {selectedItem?.corsista?.nome} {selectedItem?.corsista?.cognome}</p>
              <p className="mb-1"><strong>Partner:</strong> {selectedItem?.partner?.nome} {selectedItem?.partner?.cognome}</p>
              <p className="mb-1"><strong>Corso:</strong> {selectedItem?.denominazione_corso}</p>
              {
                selectedItem?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && (
                  <p className="mb-1">
                    <strong>Date corso:</strong> {new Date(selectedItem?.data_inizio).toLocaleDateString('it-IT')} - {new Date(selectedItem?.data_fine).toLocaleDateString('it-IT')}
                  </p>
                ) 
              }
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-sm-6 my-2'>
          <span className='small text-muted d-block mb-1'><b>Sconto corsista (in €)</b></span>
          <input 
            name="sconto" 
            value={selectedItem?.sconto || ''} 
            className="form-control" 
            type="number" 
            disabled
          />
        </div>
        <div className='col-sm-6 my-2'>
          <span className='small text-muted d-block mb-1'><b>Provvigione partner (in €)</b></span>
          <input 
            name="provvigione" 
            value={selectedItem?.provvigione_partner || ''} 
            className="form-control" 
            type="number" 
            disabled
          />
        </div>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block mb-1'><b>Numero fattura</b></span>
          <input 
            name="numero_fattura" 
            value={formContabilizzazioneManager.numero_fattura || ''} 
            onChange={handleInputChange} 
            className="form-control" 
            type="text" 
            placeholder="Inserisci numero fattura"
          />
        </div>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block mb-1'><b>Data fattura</b></span>
          <DatePicker
            selected={formContabilizzazioneManager.data_fattura || null}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            className="form-control"
            locale="it"
            placeholderText="Seleziona data fattura"
            maxDate={new Date()}
          />
        </div>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block mb-1'><b>Note</b></span>
          <textarea 
            name="note" 
            value={formContabilizzazioneManager.note || ''} 
            onChange={handleInputChange} 
            className="form-control" 
            rows="3"
            placeholder="Inserisci note"
          />
        </div>
      </div>
    </div>
  );
}
